(function () {
  'use strict';

  var config = window.MeilisearchProductGridConfig;
  if (!config) {
    console.error('[ms-pg] MeilisearchProductGridConfig not found.');
    return;
  }

  var MEILISEARCH_HOST = config.meilisearchHost;
  var MEILISEARCH_API_KEY = config.meilisearchApiKey;
  var MEILISEARCH_INDEX = config.meilisearchIndex;
  var collectionId = config.collectionId || null;
  var collectionHandle = config.collectionHandle || null;
  var currentLocale = config.currentLocale || 'de';
  var showOutOfStock = config.showOutOfStock !== false;
  var productsPerPage = config.productsPerPage || 24;
  var ETRUSTED_WIDGET_ID = config.etrustedWidgetId || '';
  var ETRUSTED_ACCENT_COLOR = config.etrustedAccentColor || '#ffdc0f';
  var PLACEHOLDER_IMAGE = config.placeholderImage || 'https://aico.apps.aico.swiss/images/no-images.png';
  var INVENTORY_BAR_TAG = config.inventoryBarTag || '';
  var searchMode = config.searchMode === true;
  var initialQuery = new URLSearchParams(window.location.search).get('q') || config.initialQuery || '';

  var _search = null;
  var _searchInitialized = false;

  var filterSettings = { filters: [], showOutOfStock: true };
  try {
    if (typeof config.filterSettings === 'string') {
      filterSettings = JSON.parse(config.filterSettings);
    } else if (config.filterSettings && typeof config.filterSettings === 'object') {
      filterSettings = config.filterSettings;
    }
  } catch (e) {
    console.error('[ms-pg] Error parsing filterSettings:', e);
  }

  function escapeHtml(text) {
    if (text == null) return '';
    var d = document.createElement('div');
    d.textContent = String(text);
    return d.innerHTML;
  }

  function formatPrice(amount, currency, forceDecimals) {
    if (amount == null || amount === '') return '';
    var num = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(num)) return '';
    var isWhole = num % 1 === 0;
    var decimals = forceDecimals ? 2 : (isWhole ? 0 : 2);
    var parts = num.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    var formatted = parts.join('.') + (!forceDecimals && isWhole ? '.-' : '');
    return currency ? currency + ' ' + formatted : formatted;
  }

  var SRCSET_WIDTHS = [200, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

  function shopifyImageUrl(src, width) {
    if (!src) return src;
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function shopifySrcset(src) {
    if (!src) return '';
    return SRCSET_WIDTHS
      .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
      .join(', ');
  }

  function getLocalizedTitle(hit) {
    return hit['title_' + currentLocale] || hit.title || 'Produkt';
  }

  function getImageUrl(hit) {
    if (hit.images && hit.images.length) {
      var img = hit.images[0];
      return typeof img === 'string' ? img : (img.src || img.url || '');
    }
    return '';
  }

  function sanitizeId(val) {
    return String(val).replace(/[^a-zA-Z0-9]/g, '_');
  }

  function getFilterLabel(filter) {
    if (filter.translations && filter.translations[currentLocale]) {
      return filter.translations[currentLocale];
    }
    return filter.label || filter.meilisearchField;
  }

  var DELIVERY_ICONS = {
    green_checked: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#39C177"/><g clip-path="url(#dg1)"><path d="M4.06445 8.56323L6.31364 10.8124L11.9366 5.18945" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="dg1"><rect width="9.6" height="9.6" fill="white" transform="translate(3.19922 3.19922)"/></clipPath></defs></svg>',
    green_full: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#39C177"/></svg>',
    orange_hg: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#F99B0E"/><g clip-path="url(#dg2)"><path d="M11 12V11C11 10.05 10.55 9.1 9.75 8.55C9.6 8.45 9.5 8.3 9.5 8.15V7.85C9.5 7.7 9.6 7.55 9.75 7.45C10.55 6.9 11 5.95 11 5V4C11.3 4 11.5 3.8 11.5 3.5C11.5 3.2 11.3 3 11 3H5C4.7 3 4.5 3.2 4.5 3.5C4.5 3.8 4.7 4 5 4V5C5 5.95 5.45 6.9 6.25 7.45C6.4 7.55 6.5 7.7 6.5 7.85V8.1C6.5 8.25 6.4 8.4 6.25 8.5C5.45 9.1 5 10.05 5 11V12C4.7 12 4.5 12.2 4.5 12.5C4.5 12.8 4.7 13 5 13H11C11.3 13 11.5 12.8 11.5 12.5C11.5 12.2 11.3 12 11 12ZM6 11C6 10.35 6.3 9.75 6.85 9.35C7.25 9.05 7.5 8.6 7.5 8.15V7.85C7.5 7.35 7.25 6.9 6.85 6.6C6.3 6.25 6 5.65 6 5V4H10V5C10 5.65 9.7 6.25 9.15 6.65C8.75 6.95 8.5 7.4 8.5 7.85V8.1C8.5 8.6 8.75 9.05 9.15 9.35C9.7 9.75 10 10.35 10 11V12H6V11Z" fill="white"/></g><defs><clipPath id="dg2"><rect width="10" height="10" fill="white" transform="translate(3 3)"/></clipPath></defs></svg>',
    gray_qm: '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8.70508" r="8" fill="#9FA6AB"/><path d="M7.86105 3.3156C8.86316 3.3156 9.66386 3.59069 10.2632 4.14087C10.8723 4.69104 11.1768 5.44262 11.1768 6.3956C11.1768 7.38788 10.8625 8.13455 10.2337 8.6356C9.60491 9.13666 8.76982 9.38718 7.72842 9.38718L7.66947 10.5514H6.21053L6.13684 8.23771H6.62316C7.57614 8.23771 8.30316 8.10999 8.80421 7.85455C9.31509 7.59911 9.57053 7.1128 9.57053 6.3956C9.57053 5.8749 9.41825 5.46718 9.11368 5.17245C8.81895 4.87771 8.40632 4.73034 7.87579 4.73034C7.34526 4.73034 6.92772 4.8728 6.62316 5.15771C6.3186 5.44262 6.16632 5.84052 6.16632 6.35139H4.58947C4.58947 5.76192 4.72211 5.23631 4.98737 4.77455C5.25263 4.3128 5.63088 3.9542 6.12211 3.69876C6.62316 3.44332 7.20281 3.3156 7.86105 3.3156ZM6.91789 13.8082C6.61333 13.8082 6.35789 13.7051 6.15158 13.4988C5.94526 13.2924 5.84211 13.037 5.84211 12.7324C5.84211 12.4279 5.94526 12.1724 6.15158 11.9661C6.35789 11.7598 6.61333 11.6567 6.91789 11.6567C7.21263 11.6567 7.46316 11.7598 7.66947 11.9661C7.87579 12.1724 7.97895 12.4279 7.97895 12.7324C7.97895 13.037 7.87579 13.2924 7.66947 13.4988C7.46316 13.7051 7.21263 13.8082 6.91789 13.8082Z" fill="white"/></svg>'
  };

  function getDeliveryIcon(lieferanzeige, fallback) {
    switch (lieferanzeige) {
      case 'Lieferbar ab Lager - Icon (Green full checkmark)': return DELIVERY_ICONS.green_checked;
      case 'Dropshipping lieferbar - Icon (Green full dot)': return DELIVERY_ICONS.green_full;
      case 'Liefertermin bekannt - Icon (Blue with Sandbox)': return DELIVERY_ICONS.orange_hg;
      case 'Liefertermin unbekannt - icon (Grey with questionmark)': return DELIVERY_ICONS.gray_qm;
      default: return fallback;
    }
  }


  var _ps = window.productStrings || {};
  var _deliveryDate = _ps.deliveryDate || 'Lieferdatum';
  var _workingDays = _ps.workingDays || 'Werktage';
  var _deliveryDateUnknown = _ps.deliveryDateUnknown || 'Lieferdatum zurzeit unbekannt';
  var _deliveryBetween = _ps.deliveryBetween || 'Zwischen [from] und [to] geliefert';
  var _deliveryAvailableFrom = _ps.deliveryAvailableFrom || 'Lieferbar ab:';

  function _getMsDeliveryLocale() {
    var locale = _ps.locale || currentLocale || 'de';
    var map = { de: 'de-CH', fr: 'fr-CH', it: 'it-CH', en: 'en-GB' };
    return map[locale] || 'de-CH';
  }

  var _deliveryHolidays = (typeof window !== 'undefined' && window.deliveryHolidays) ? window.deliveryHolidays : [];
  function _toISO(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }
  function _isNonWorkingDay(d) {
    var wd = d.getDay();
    return wd === 0 || wd === 6 || _deliveryHolidays.indexOf(_toISO(d)) !== -1;
  }

  function _addWorkingDays(base, n) {
    var d = new Date(base.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (!_isNonWorkingDay(d)) added++;
    }
    return d;
  }

  function _formatShortDay(d, locale) {
    var wd = d.toLocaleDateString(locale, { weekday: 'short' }).replace('.', '');
    wd = wd.charAt(0).toUpperCase() + wd.slice(1);
    return wd + ', ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
  }

  // Verarbeitungsstart mit 17-Uhr-Cutoff, immer in Shop-Zeit (Europe/Zurich),
  // unabhaengig von der Zeitzone des Besuchers. Nach 17:00 Uhr sowie an
  // Wochenenden/Feiertagen beginnt die Zaehlung erst am naechsten Werktag.
  function _getProcessingStart() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    function _get(t) {
      for (var i = 0; i < parts.length; i++) { if (parts[i].type === t) return parts[i].value; }
      return '';
    }
    var y = parseInt(_get('year'), 10);
    var m = parseInt(_get('month'), 10);
    var day = parseInt(_get('day'), 10);
    var hour = parseInt(_get('hour'), 10);
    if (isNaN(hour) || hour === 24) hour = 0;
    var start = new Date(y, m - 1, day);
    if (hour >= 17) {
      start.setDate(start.getDate() + 1);
    }
    while (_isNonWorkingDay(start)) {
      start.setDate(start.getDate() + 1);
    }
    return start;
  }

  function _deliveryRangeText(minD, maxD) {
    var locale = _getMsDeliveryLocale();
    var base = _getProcessingStart();
    var from = _formatShortDay(_addWorkingDays(base, minD), locale);
    var to = _formatShortDay(_addWorkingDays(base, maxD), locale);
    return _deliveryBetween.replace('[from]', from).replace('[to]', to);
  }

  function getDeliveryStatus(hit) {
    var tags = hit.tags || [];
    var isDropship = tags.indexOf('cf_DropshippingDropshipping') !== -1;
    var variants = hit.variants || [];
    var variantInStock = variants.some(function (v) { return (v.inventoryQuantity || 0) > 0; });
    var inStock = (hit.totalInventory || 0) > 0 || variantInStock;
    var sellsWhenOOS = variants.some(function (v) {
      return String(v.inventoryPolicy || '').toUpperCase() === 'CONTINUE';
    });
    var soldOut = !inStock && !sellsWhenOOS;
    var lieferanzeige = '';
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('cf_Lieferanzeige_') === 0) {
        lieferanzeige = tags[i].replace('cf_Lieferanzeige_', '');
        break;
      }
    }

    var hasLkwPrioTag = false;
    var isDelivery2 = false;
    for (var s = 0; s < tags.length; s++) {
      var smIdx = tags[s].indexOf('Shipment Method_');
      if (smIdx !== -1) {
        var smValue = tags[s].substring(smIdx + 'Shipment Method_'.length).toLowerCase();
        if (smValue === 'lkw_prio') { hasLkwPrioTag = true; }
      }
      if (tags[s] === 'delivery_2') { isDelivery2 = true; }
    }
    var isLkwPrio = hasLkwPrioTag && isDelivery2;

    var langSuffix = currentLocale === 'de' ? 'de_ch' : currentLocale;
    var raw = hit['metafield_aico_aico_custom_fields_' + langSuffix];
    var metafields = [];
    if (Array.isArray(raw)) {
      metafields = raw;
    } else if (typeof raw === 'string' && raw) {
      try { metafields = JSON.parse(raw); } catch (e) { metafields = []; }
    }
    var nachlieferungKey = 'nachlieferung_' + langSuffix;
    var nachlieferungEntry = null;
    for (var j = 0; j < metafields.length; j++) {
      if (metafields[j].key === nachlieferungKey) { nachlieferungEntry = metafields[j]; break; }
    }
    var nachlieferungRaw = (nachlieferungEntry && nachlieferungEntry.value) || '';
    var hasNachlieferung = false;
    var nachlieferungDate = '';
    var nachlieferungShort = '';
    if (nachlieferungRaw && nachlieferungRaw !== '01/01/01') {
      var restockDate = new Date(nachlieferungRaw);
      var ts = restockDate.getTime();
      if (!isNaN(ts) && ts > Date.now()) {
        hasNachlieferung = true;
        // Nachlieferdatum darf nicht auf ein Wochenende oder einen Feiertag
        // fallen: auf den naechsten Werktag verschieben.
        while (_isNonWorkingDay(restockDate)) {
          restockDate.setDate(restockDate.getDate() + 1);
        }
        var msLocale = _getMsDeliveryLocale();
        nachlieferungShort = _formatShortDay(restockDate, msLocale);
        nachlieferungDate = restockDate.toLocaleDateString(msLocale);
      }
    }

    var text, icon;

    if (isLkwPrio && !isDropship) {
      var lkwIcon;
      if (inStock) {
        lkwIcon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.green_checked);
      } else if (hasNachlieferung) {
        lkwIcon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.orange_hg);
      } else {
        lkwIcon = getDeliveryIcon('', DELIVERY_ICONS.gray_qm);
      }
      var lkwText;
      if (!inStock && hasNachlieferung && soldOut) {
        lkwText = _deliveryDateUnknown;
        lkwIcon = getDeliveryIcon('', DELIVERY_ICONS.gray_qm);
      } else if (!inStock && hasNachlieferung) {
        lkwText = _deliveryAvailableFrom + ' ' + nachlieferungShort;
      } else {
        lkwText = _deliveryRangeText(3, 4);
      }
      return { icon: lkwIcon, text: lkwText, needsBrandLookup: false, vendor: hit.vendor || '', lieferanzeige: lieferanzeige };
    }

    if (!isDropship) {
      if (inStock) {
        /* cases 1 & 2 - in stock, ship from warehouse */
        text = _deliveryRangeText(1, 2);
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.green_checked);
      } else if (hasNachlieferung && !soldOut) {
        /* case 3 - out of stock, known restock date */
        text = _deliveryAvailableFrom + ' ' + nachlieferungShort;
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.orange_hg);
      } else {
        /* case 4 - out of stock, unknown date */
        text = _deliveryDateUnknown;
        icon = getDeliveryIcon('', DELIVERY_ICONS.gray_qm);
      }
    } else {
      if (hasNachlieferung) {
        /* case 5 - dropship, known restock date */
        text = _deliveryDate + ': ' + nachlieferungDate;
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.orange_hg);
      } else if (inStock) {
        /* case exception - dropship, in stock */
        text = _deliveryRangeText(1, 2);
        icon = getDeliveryIcon(lieferanzeige, DELIVERY_ICONS.green_checked);
      } else {
        /* case 6 - dropship, no date, out of stock — resolved by brand API lookup */
        text = '';
        icon = DELIVERY_ICONS.green_full;
      }
    }

    return { icon: icon, text: text, needsBrandLookup: isDropship && !hasNachlieferung && !inStock, vendor: hit.vendor || '', lieferanzeige: lieferanzeige };
  }

  // Self-contained brand delivery days fetch (independent from delivery-rules.js)
  var _msBrandCache = {};
  function _msFetchBrandDays(brand) {
    if (_msBrandCache[brand]) return _msBrandCache[brand];
    var apiUrl = (typeof aico_get_data === 'function') ? aico_get_data('API_URL') : (window.API_URL || '');
    var authToken = (typeof aico_get_data === 'function') ? aico_get_data('Authorization') : (window.Authorization || '');
    // No token needed, aico calls go through the app proxy
    if (!apiUrl) {
      _msBrandCache[brand] = Promise.resolve(null);
      return _msBrandCache[brand];
    }
    _msBrandCache[brand] = fetch(apiUrl + 'brands?filter[shouldExcludeProducts]=1&filter[isLightVersion]=0&filter[name]=' + encodeURIComponent(brand), {
      method: 'GET',
      headers: { 'Authorization': authToken, 'Accept': 'application/vnd.api+json' }
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) { return data.data && data.data[0] ? data.data[0].attributes : null; })
      .catch(function () { return null; });
    return _msBrandCache[brand];
  }

  // Brand API lookup for case 6 (dropship, OOS, no restock date)
  function fetchMsBrandDelivery() {
    var cards = document.querySelectorAll('.ms-delivery-status[data-needs-brand-lookup="true"]');
    if (!cards.length) return;

    var vendorMap = {};
    cards.forEach(function (el) {
      var vendor = el.getAttribute('data-vendor');
      if (vendor) {
        if (!vendorMap[vendor]) vendorMap[vendor] = [];
        vendorMap[vendor].push(el);
      }
    });

    Object.keys(vendorMap).forEach(function (vendor) {
      _msFetchBrandDays(vendor).then(function (brandData) {
        var els = vendorMap[vendor];
        if (brandData && brandData.numberOfDeliveryDays) {
          // numberOfDeliveryDays kommt als String aus der API -> in Zahl wandeln,
          // damit "+ 1" rechnet (Spanne: N bis N+1 Werktage) und nicht verkettet.
          var brandDays = parseInt(brandData.numberOfDeliveryDays, 10) || 0;
          els.forEach(function (el) {
            var la = el.getAttribute('data-lieferanzeige') || '';
            el.querySelector('.ms-delivery-icon').innerHTML = getDeliveryIcon(la, DELIVERY_ICONS.green_full);
            el.querySelector('.ms-delivery-text').textContent = _deliveryRangeText(brandDays, brandDays + 1);
            el.removeAttribute('data-needs-brand-lookup');
          });
        } else {
          els.forEach(function (el) {
            el.querySelector('.ms-delivery-icon').innerHTML = getDeliveryIcon('', DELIVERY_ICONS.gray_qm);
            el.querySelector('.ms-delivery-text').textContent = _deliveryDateUnknown;
            el.removeAttribute('data-needs-brand-lookup');
          });
        }
      });
    });
  }

  function _reinitSwym() {
    if (window._swat) {
      if (typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons('#ms-hits');
      } else if (typeof window._swat.postLoader === 'function') {
        window._swat.postLoader();
      }
    }
  }

  var _compareIds = {};
  function _refreshCompareIds() {
    _compareIds = {};
    try {
      (JSON.parse(localStorage.getItem('compareList')) || []).forEach(function (item) {
        if (item.productId) _compareIds[item.productId] = true;
      });
    } catch (e) { }
  }
  _refreshCompareIds();

  function renderInventoryBar(hit) {
    if (!INVENTORY_BAR_TAG) return '';
    if ((hit.tags || []).indexOf(INVENTORY_BAR_TAG) === -1) return '';

    var total = parseInt(hit.metafield_custom_deal_inventar, 10);
    var sold = parseInt(hit.metafield_custom_verkauftes_deal_inventar, 10);
    if (!total || isNaN(total) || total <= 0) return '';
    if (isNaN(sold)) sold = 0;
    if (sold >= total) return '';

    var percentSold = Math.floor(sold * 100 / total);
    var percentRemaining = 100 - percentSold;
    var remaining = total - sold;

    var text;
    if (currentLocale === 'de') text = remaining + ' von ' + total + ' erhältlich';
    else if (currentLocale === 'fr') text = remaining + ' sur ' + total + ' disponibles';
    else text = remaining + ' out of ' + total + ' available';

    return `
      <div class="inventory_progress_bar_wrapper">
        <div class="progress_bar__text">${escapeHtml(text)}</div>
        <div class="progress_bar" data-sold="${percentSold}" data-remaining="${percentRemaining}" style="--total-sold:${percentSold}%;--total-remaining:${percentRemaining}%"></div>
      </div>
    `;
  }

  function renderHitHtml(hit) {
    var product_id = hit.id || '';
    var product_variant_id = hit.variants && hit.variants[0] && hit.variants[0].id ? hit.variants[0].id : '';
    var title = getLocalizedTitle(hit);
    var currency = (hit.price && hit.price.currency) || 'CHF';
    var price = (hit.price && parseFloat(hit.price.minPrice)) ||
      (hit.variants && hit.variants[0] && parseFloat(hit.variants[0].price)) || 0;
    var compareAtPrice = (hit.variants && hit.variants[0] && parseFloat(hit.variants[0].compareAtPrice)) || 0;
    var isSale = compareAtPrice > 0 && compareAtPrice > price;
    var isNew = hit.isNew === true;
    var imgSrc = getImageUrl(hit) || PLACEHOLDER_IMAGE;
    var imgSrc2 = (hit.images && hit.images.length > 1)
      ? (typeof hit.images[1] === 'string' ? hit.images[1] : (hit.images[1].src || hit.images[1].url || ''))
      : '';
    var handle = hit.handle || hit.product_handle || '';
    var localizedHandle = hit['handle_' + currentLocale] || handle;
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = rootPath + 'products/' + localizedHandle;
    var sku = (hit.variants && hit.variants[0] && hit.variants[0].sku) || '';
    var delivery = getDeliveryStatus(hit);

    var energyBadge = '';
    (function () {
      var etags = hit.tags || [];
      var cls = '', bg = '', fg = '';
      if (etags.indexOf('class-a-plus-plus') !== -1) { cls = 'A++'; bg = '#50b848'; fg = '#ffffff'; }
      else if (etags.indexOf('class-a-plus') !== -1) { cls = 'A+'; bg = '#a9cf2e'; fg = '#143300'; }
      else if (etags.indexOf('class-a') !== -1) { cls = 'A'; bg = '#d6e02a'; fg = '#2a3300'; }
      if (cls) {
        energyBadge = '<span class="el-energy-badge" style="background:' + bg + ';color:' + fg + '">' + cls + '</span>';
      }
    })();
    var product_collection = '';
    var productImage = hit.images && hit.images.length > 0 ? (typeof hit.images[0] === 'string' ? hit.images[0] : (hit.images[0].src || hit.images[0].url || '')) : '';

    var saleBadge = '';
    if (isSale) {
      var showAsPercentage = (hit.tags || []).some(function (t) { return t.indexOf('Preisanzeige_in_Rabatt') !== -1; });
      var badgeText = showAsPercentage
        ? '-' + Math.round(100 * (compareAtPrice - price) / compareAtPrice) + '%'
        : '-' + formatPrice(compareAtPrice - price, currency, true);
      saleBadge = `
        <div class="ms-card-badge">
          <span class="ms-badge">
            <span class="ms-badge-text">
              ${badgeText}
            </span>
          </span>
        </div>
      `;
    }

    var priceHtml = '';
    if (isSale && compareAtPrice > 0) {
      priceHtml = `
        <div class="ms-price">
          <div class="ms-price-sale">
            <span class="ms-price-sale-item">${formatPrice(price, null)}</span>
            <span>
              <s class="ms-price-regular-item">
                <span class="ms-statt-label">${currentLocale === 'fr' ? 'au lieu de' : 'statt'}</span>
                ${formatPrice(compareAtPrice, null)}
              </s>
            </span>
          </div>
        </div>
      `;
    } else {
      priceHtml = `<div class="ms-price ms-price-regular">${formatPrice(price, null)}</div>`;
    }

    var compareActive = _compareIds[product_id] ? ' icon-compare-active' : '';
    const compareButton = `<button type="button" class="icon icon-compare${compareActive}" aria-label="Compare product" data-productid="${product_id}" data-productname="${title}" data-collection="${product_collection}" data-image="${productImage}" data-productHandle="${handle}">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.14009 1.10449H0.700014C0.3134 1.10449 0 1.41793 0 1.80451V19.1969C0 19.5834 0.3134 19.8969 0.700014 19.8969H9.14009C9.52666 19.8969 9.8401 19.5835 9.8401 19.1969V1.80451C9.8401 1.41793 9.52674 1.10449 9.14009 1.10449ZM8.44007 18.4969H1.39999V2.50452H8.44007V18.4969Z" fill="#979797"></path>
        <path d="M6.21378 4.91113H3.62775C3.24118 4.91113 2.92773 5.22453 2.92773 5.61115C2.92773 5.99776 3.24113 6.31116 3.62775 6.31116H6.21378C6.60036 6.31116 6.9138 5.99776 6.9138 5.61115C6.9138 5.22453 6.6004 4.91113 6.21378 4.91113Z" fill="#979797"></path>
        <path d="M6.21378 8.1709H3.62775C3.24118 8.1709 2.92773 8.4843 2.92773 8.87091C2.92773 9.25753 3.24113 9.57093 3.62775 9.57093H6.21378C6.60036 9.57093 6.9138 9.25753 6.9138 8.87091C6.9138 8.4843 6.6004 8.1709 6.21378 8.1709Z" fill="#979797"></path>
        <path d="M6.21378 11.4307H3.62775C3.24118 11.4307 2.92773 11.7441 2.92773 12.1307C2.92773 12.5172 3.24113 12.8307 3.62775 12.8307H6.21378C6.60036 12.8307 6.9138 12.5173 6.9138 12.1307C6.9138 11.7441 6.6004 11.4307 6.21378 11.4307Z" fill="#979797"></path>
        <path d="M6.21378 14.6875H3.62775C3.24118 14.6875 2.92773 15.0009 2.92773 15.3875C2.92773 15.7741 3.24113 16.0875 3.62775 16.0875H6.21378C6.60036 16.0875 6.9138 15.7741 6.9138 15.3875C6.9138 15.0009 6.6004 14.6875 6.21378 14.6875Z" fill="#979797"></path>
        <path d="M20.2963 1.10254H11.8563C11.4697 1.10254 11.1562 1.41594 11.1562 1.80255V19.1949C11.1562 19.5815 11.4697 19.8949 11.8563 19.8949H20.2963C20.6829 19.8949 20.9964 19.5815 20.9964 19.1949V1.80255C20.9964 1.41598 20.683 1.10254 20.2963 1.10254ZM19.5964 18.4949H12.5563V2.50257H19.5964V18.4949Z" fill="#979797"></path>
        <path d="M17.3759 4.91113H14.7899C14.4033 4.91113 14.0898 5.22453 14.0898 5.61115C14.0898 5.99776 14.4032 6.31116 14.7899 6.31116H17.3759C17.7625 6.31116 18.0759 5.99776 18.0759 5.61115C18.0759 5.22453 17.7625 4.91113 17.3759 4.91113Z" fill="#979797"></path>
        <path d="M17.3759 8.1709H14.7899C14.4033 8.1709 14.0898 8.4843 14.0898 8.87091C14.0898 9.25753 14.4032 9.57093 14.7899 9.57093H17.3759C17.7625 9.57093 18.0759 9.25753 18.0759 8.87091C18.0759 8.4843 17.7625 8.1709 17.3759 8.1709Z" fill="#979797"></path>
        <path d="M17.3759 11.4307H14.7899C14.4033 11.4307 14.0898 11.7441 14.0898 12.1307C14.0898 12.5172 14.4032 12.8307 14.7899 12.8307H17.3759C17.7625 12.8307 18.0759 12.5173 18.0759 12.1307C18.0759 11.7441 17.7625 11.4307 17.3759 11.4307Z" fill="#979797"></path>
        <path d="M17.3759 14.6875H14.7899C14.4033 14.6875 14.0898 15.0009 14.0898 15.3875C14.0898 15.7741 14.4032 16.0875 14.7899 16.0875H17.3759C17.7625 16.0875 18.0759 15.7741 18.0759 15.3875C18.0759 15.0009 17.7625 14.6875 17.3759 14.6875Z" fill="#979797"></path>
        </svg>
      </button>
    `;
    const wishListHtml = `<button aria-label="${title}" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${product_id} swym-icon swym-heart" data-swaction="addToWishlist" data-product-id="${product_id}" data-variant-id="${product_variant_id}" data-product-url="${window.location.origin}${url}"><svg class="icon-custom no-fill" width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.9191 3.93654C23.2187 2.82587 22.1929 1.95816 20.9814 1.45167C19.6087 0.875503 18.067 0.771792 16.523 1.1525C15.108 1.50143 13.7298 2.25822 12.5 3.35607C11.27 2.25812 9.89166 1.50128 8.47652 1.15241C6.93243 0.771548 5.39058 0.875356 4.01793 1.45192C2.80645 1.95856 1.78067 2.82644 1.08038 3.93727C0.346978 5.09665 -0.0261177 6.50656 0.00142139 8.01442C0.123687 14.7178 10.1091 20.8133 12.1096 21.9673C12.2283 22.0358 12.3629 22.0718 12.5 22.0718C12.637 22.0718 12.7716 22.0358 12.8903 21.9673C14.891 20.8132 24.8773 14.7166 24.9985 8.01325C25.0258 6.50548 24.6525 5.09572 23.9191 3.93654ZM23.4363 7.98517C23.3973 10.1526 21.9524 12.6795 19.2585 15.2925C16.7636 17.7124 13.9257 19.5363 12.5 20.385C11.0742 19.5364 8.23677 17.7128 5.74214 15.2928C3.048 12.6799 1.60318 10.1532 1.56363 7.9859C1.52046 5.61935 2.66417 3.7153 4.623 2.8925C5.26498 2.62435 5.95419 2.48758 6.64991 2.49025C8.44654 2.49025 10.347 3.35998 11.9429 4.98273C12.0156 5.05666 12.1023 5.11537 12.1979 5.15545C12.2935 5.19553 12.3962 5.21617 12.4999 5.21617C12.6036 5.21617 12.7062 5.19553 12.8019 5.15545C12.8975 5.11537 12.9842 5.05666 13.0569 4.98273C15.274 2.72833 18.0789 1.92741 20.3762 2.89235C22.3353 3.71486 23.4791 5.61862 23.4363 7.98502V7.98517Z" fill="currentColor"></path></svg><svg class="icon-custom with-fill" width="24" height="24" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 512 512"><path class="st0" fill="currentColor" d="M489.9,101.1c-14.3-22.8-35.3-40.5-60.2-50.9-28.1-11.8-59.7-13.9-91.3-6.1-29,7.1-57.2,22.6-82.4,45.1-25.2-22.5-53.4-38-82.4-45.1-31.6-7.8-63.2-5.7-91.3,6.1-24.8,10.4-45.8,28.2-60.2,50.9C7.1,124.9-.5,153.7,0,184.6c2.5,137.3,207,262.1,248,285.8,4.9,2.8,11,2.8,16,0,41-23.6,245.5-148.5,248-285.8.6-30.9-7.1-59.8-22.1-83.5ZM480,184h0c-.8,44.4-30.4,96.1-85.6,149.7-51.1,49.6-109.2,86.9-138.4,104.3-29.2-17.4-87.3-54.7-138.4-104.3-55.2-53.5-84.8-105.3-85.6-149.6-.9-48.5,22.5-87.5,62.7-104.3,13.2-5.5,27.3-8.3,41.5-8.2,36.8,0,75.7,17.8,108.4,51.1,6.2,6.3,16.3,6.4,22.6.2,0,0,.1-.1.2-.2,45.4-46.2,102.9-62.6,149.9-42.8,40.1,16.8,63.5,55.8,62.7,104.3Z"></path><path class="st0" fill="currentColor" d="M512,184.6c-2.5,137.3-207,262.1-248,285.8-5,2.8-11,2.8-16,0C207,446.7,2.5,321.9,0,184.6c-.6-30.9,7.1-59.8,22.1-83.5,14.3-22.8,35.3-40.5,60.2-50.9,28.1-11.8,59.7-13.9,91.3-6.1,29,7.1,57.2,22.6,82.4,45.1,25.2-22.5,53.4-38,82.4-45.1,31.6-7.8,63.2-5.7,91.3,6.1,24.8,10.4,45.8,28.1,60.2,50.9,15,23.7,22.7,52.6,22.1,83.5Z"></path></svg><span class="swym-tooltip swym-inject swym-tooltip-clickable"><span class="swym-tooltip-text">Zur Wunschliste hinzufügen</span></span></button>`;

    return `
      <li class="ms-product-card-container">
        <div class="ms-product-card">
          <div class="ms-card-top-icon">
            ${saleBadge}
            <div class="ms-card-top-right-icons">
              ${compareButton}
              ${wishListHtml}
            </div>
          </div>

          <div class="ms-card-image">
            <a href="${url}" aria-label="${title}" ${imgSrc2 ? 'class="ms-has-second-image"' : ''}>
              <img class="ms-img ms-img-primary"
                src="${shopifyImageUrl(imgSrc, 540)}"
                srcset="${shopifySrcset(imgSrc)}"
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
                alt="${escapeHtml(title)}"
                loading="eager">
              ${imgSrc2 ? `<img class="ms-img ms-img-secondary"
                src="${shopifyImageUrl(imgSrc2, 540)}"
                srcset="${shopifySrcset(imgSrc2)}"
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
                alt="${escapeHtml(title)}"
                loading="lazy">` : ''}
            </a>
          </div>

          <div class="ms-card-content">
            ${priceHtml}
            <div class="ms-product-rating">${ETRUSTED_WIDGET_ID && sku ? `<etrusted-widget data-etrusted-widget-id="${ETRUSTED_WIDGET_ID}" data-sku="${escapeHtml(sku)}" data-accent-color="${ETRUSTED_ACCENT_COLOR}"></etrusted-widget>` : ''}${energyBadge}</div>
            ${renderInventoryBar(hit)}
            <div class="ms-card-title">
              <h3><a href="${url}">${title}</a></h3>
            </div>
            <div class="ms-delivery-status"${delivery.needsBrandLookup ? ' data-needs-brand-lookup="true" data-vendor="' + escapeHtml(delivery.vendor) + '" data-lieferanzeige="' + escapeHtml(delivery.lieferanzeige) + '"' : ''}>
              <span class="ms-delivery-icon">${delivery.icon}</span><span class="ms-delivery-text">${escapeHtml(delivery.text)}</span>
            </div>
          </div>

          <div class="ms-product-view">
            <a href="${url}">${currentLocale === 'fr' ? 'Voir' : 'Ansehen'}</a>
          </div>
        </div>
      </li>
    
    `;
  }

  function renderSkeletons(count) {
    var b = 'background:#e5e5e5;border-radius:8px;';
    var card =
      '<li class="ms-product-card-container" style="pointer-events:none">' +
      '<div class="ms-product-card" style="min-height:420px">' +
      '<div class="ms-card-top-icon"><div style="' + b + 'width:60px;height:22px;border-radius:15px"></div></div>' +
      '<div class="ms-card-image"><div style="' + b + 'width:100%;height:200px"></div></div>' +
      '<div style="padding:15px;display:flex;flex-direction:column;gap:10px">' +
      '<div style="' + b + 'height:18px;width:85%"></div>' +
      '<div style="' + b + 'height:18px;width:55%"></div>' +
      '<div style="' + b + 'height:14px;width:100px"></div>' +
      '<div style="' + b + 'height:24px;width:90px"></div>' +
      '</div>' +
      '</div>' +
      '</li>';
    var html = '';
    for (var i = 0; i < count; i++) html += card;
    return html;
  }

  function getEffectiveField(filter) {
    if (filter.translatable && filter.meilisearchFields && filter.meilisearchFields[currentLocale]) {
      return filter.meilisearchFields[currentLocale];
    }
    return filter.meilisearchField;
  }

  function isSliderFilter(f) {
    return f.displayMode === 'slider' && f.numeric === true;
  }

  function checkAndInit() {
    if (_searchInitialized) return true;
    if (typeof window.instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
      _searchInitialized = true;
      startSearch();
      return true;
    }
    return false;
  }

  function initSearch() {
    if (checkAndInit()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (checkAndInit() || attempts > 50) {
        clearInterval(timer);
        if (attempts > 50) {
          console.error('[ms-pg] InstantSearch libraries failed to load.');
          window.dispatchEvent(new CustomEvent('meilisearch_grid_loaded'));
        }
      }
    }, 100);
  }

  function startSearch() {
    var _msGridLoaded = false;
    var searchClient = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_API_KEY, {
      primaryKey: 'id',
      finitePagination: true,
      keepZeroFacets: false
    });

    var baseFilters = [];
    if (collectionId) baseFilters.push('collections.id = ' + collectionId);
    if (!showOutOfStock) baseFilters.push('(totalInventory > 0 OR variants.inventoryPolicy = "CONTINUE")');
    var baseFilterString = baseFilters.join(' AND ');

    var DEFAULT_SORT = MEILISEARCH_INDEX + ':filter_score:desc';

    var sortedFilters = (filterSettings.filters || [])
      .filter(function (f) {
        if (!f.excludedOnCollections || !f.excludedOnCollections.length) return true;
        return f.excludedOnCollections.indexOf(collectionHandle) === -1;
      })
      .sort(function (a, b) { return a.position - b.position; });

    _search = window.instantsearch({
      indexName: DEFAULT_SORT,
      searchClient: searchClient.searchClient,
      insights: false,
      routing: {
        stateMapping: {
          stateToRoute: function (uiState) {
            var idx = uiState[Object.keys(uiState)[0]] || {};
            var route = {};
            if (idx.refinementList) {
              Object.keys(idx.refinementList).forEach(function (attr) {
                var vals = idx.refinementList[attr];
                if (vals && vals.length) {
                  var key = attr.indexOf('filter_') === 0 ? attr.slice(7) : attr;
                  route[key] = vals.join(',');
                }
              });
            }
            // Custom sliders: write _min / _max independently
            sortedFilters.forEach(function (f) {
              if (!isSliderFilter(f)) return;
              var s = sliders[f.meilisearchField];
              if (!s) return;
              var urlKey = f.meilisearchField.indexOf('filter_') === 0 ? f.meilisearchField.slice(7) : f.meilisearchField;
              if (s.appliedMin != null) route[urlKey + '_min'] = s.appliedMin;
              if (s.appliedMax != null) route[urlKey + '_max'] = s.appliedMax;
            });
            if (idx.sortBy && idx.sortBy !== DEFAULT_SORT) {
              route.sort = idx.sortBy.replace(MEILISEARCH_INDEX + ':', '');
            }
            if (searchMode && idx.query) route.q = idx.query;
            return route;
          },
          routeToState: function (route) {
            var reserved = { sort: true, q: true };
            var filterKeys = {};
            sortedFilters.forEach(function (f) {
              if (isSliderFilter(f)) {
                var urlKey = f.meilisearchField.indexOf('filter_') === 0 ? f.meilisearchField.slice(7) : f.meilisearchField;
                reserved[urlKey + '_min'] = true;
                reserved[urlKey + '_max'] = true;
                return;
              }
              var effField = getEffectiveField(f);
              var short = f.meilisearchField.indexOf('filter_') === 0
                ? f.meilisearchField.slice(7)
                : f.meilisearchField;
              filterKeys[short] = effField;
              if (effField !== f.meilisearchField) {
                var effShort = effField.indexOf('filter_') === 0 ? effField.slice(7) : effField;
                filterKeys[effShort] = effField;
              }
            });
            var refinementList = {};
            Object.keys(route).forEach(function (key) {
              if (reserved[key]) return;
              var attr = filterKeys[key] || key;
              if (route[key]) refinementList[attr] = route[key].split(',');
            });
            var state = {};
            if (Object.keys(refinementList).length) state.refinementList = refinementList;
            // Restore range filters — partial ranges supported: "100:" = only min, ":500" = only max
            var range = {};
            function buildRangeStr(rawMin, rawMax) {
              var mn = (rawMin != null && rawMin !== '') ? parseFloat(rawMin) : NaN;
              var mx = (rawMax != null && rawMax !== '') ? parseFloat(rawMax) : NaN;
              if (isNaN(mn) && isNaN(mx)) return null;
              return (isNaN(mn) ? '' : mn) + ':' + (isNaN(mx) ? '' : mx);
            }
            sortedFilters.forEach(function (f) {
              if (!isSliderFilter(f)) return;
              var ef = getEffectiveField(f);
              var urlKey = f.meilisearchField.indexOf('filter_') === 0 ? f.meilisearchField.slice(7) : f.meilisearchField;
              var s = buildRangeStr(route[urlKey + '_min'], route[urlKey + '_max']);
              if (s) range[ef] = s;
            });
            if (Object.keys(range).length) state.range = range;
            if (route.sort) state.sortBy = MEILISEARCH_INDEX + ':' + route.sort;
            if (searchMode) state.query = route.q || initialQuery;
            var uiState = {};
            uiState[DEFAULT_SORT] = state;
            return uiState;
          }
        }
      }
    });

    var configureOptions = { hitsPerPage: productsPerPage };
    if (baseFilterString) configureOptions.filters = baseFilterString;
    _search.addWidgets([window.instantsearch.widgets.configure(configureOptions)]);

    var fieldLabelMap = {};
    sortedFilters.forEach(function (f) {
      var eff = getEffectiveField(f);
      fieldLabelMap[f.meilisearchField] = getFilterLabel(f);
      if (eff !== f.meilisearchField) fieldLabelMap[eff] = getFilterLabel(f);
    });
    var effectiveFieldToFilter = {};
    sortedFilters.forEach(function (f) {
      effectiveFieldToFilter[getEffectiveField(f)] = f;
    });

    var sliders = {};

    sortedFilters.forEach(function (filter) {
      var baseField = filter.meilisearchField;
      var effectiveField = getEffectiveField(filter);

      if (isSliderFilter(filter)) {
        var facetEl = document.getElementById('ms-facet-' + baseField);
        var minInput = document.getElementById('ms-slider-min-' + baseField);
        var maxInput = document.getElementById('ms-slider-max-' + baseField);
        var sliderFill = document.getElementById('ms-slider-fill-' + baseField);
        var valMin = document.getElementById('ms-range-val-min-' + baseField);
        var valMax = document.getElementById('ms-range-val-max-' + baseField);
        if (!facetEl || !minInput || !maxInput) return;

        sliders[baseField] = { refine: null, appliedMin: null, appliedMax: null };

        (function (bf, ef, facetEl, minInp, maxInp, fill, vMin, vMax, pre, suf, step) {
          var isDecimal = step < 1;
          function fmtVal(n) {
            var formatted = isDecimal
              ? n.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, "'")
              : Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
            return (pre ? pre + ' ' : '') + formatted + (suf ? ' ' + suf : '');
          }
          function updateUI() {
            if (!minInp || !maxInp || !fill) return;
            var min = parseFloat(minInp.value);
            var max = parseFloat(maxInp.value);
            var rangeMin = parseFloat(minInp.min) || 0;
            var rangeMax = parseFloat(minInp.max) || 9999;
            var total = rangeMax - rangeMin;
            if (total <= 0) return;
            var leftPct = ((min - rangeMin) / total) * 100;
            var rightPct = ((max - rangeMin) / total) * 100;
            fill.style.left = leftPct + '%';
            fill.style.width = (rightPct - leftPct) + '%';
            if (vMin) vMin.textContent = fmtVal(min);
            if (vMax) vMax.textContent = fmtVal(max);
          }

          // input → only visual feedback during drag
          minInp.addEventListener('input', function () {
            if (parseFloat(minInp.value) >= parseFloat(maxInp.value)) minInp.value = parseFloat(maxInp.value) - 1;
            updateUI();
          });
          maxInp.addEventListener('input', function () {
            if (parseFloat(maxInp.value) <= parseFloat(minInp.value)) maxInp.value = parseFloat(minInp.value) + 1;
            updateUI();
          });

          // change on MIN thumb → apply only >= refinement independently
          minInp.addEventListener('change', function () {
            var min = parseFloat(minInp.value);
            var rangeMin = parseFloat(minInp.min);
            // Set BEFORE helper.search() — stateToRoute fires immediately on helper change
            sliders[bf].appliedMin = (min > rangeMin) ? min : null;
            _search.helper.removeNumericRefinement(ef, '>=');
            if (min > rangeMin) {
              _search.helper.addNumericRefinement(ef, '>=', min);
            } else {
            }
            _search.helper.search();
          });

          // change on MAX thumb → apply only <= refinement independently
          maxInp.addEventListener('change', function () {
            var max = parseFloat(maxInp.value);
            var rangeMax = parseFloat(maxInp.max);
            // Set BEFORE helper.search() — stateToRoute fires immediately on helper change
            sliders[bf].appliedMax = (max < rangeMax) ? max : null;
            _search.helper.removeNumericRefinement(ef, '<=');
            if (max < rangeMax) {
              _search.helper.addNumericRefinement(ef, '<=', max);
            } else {
            }
            _search.helper.search();
          });

          var _initialized = false;
          var renderSlider = window.instantsearch.connectors.connectRange(
            function (renderState) {
              sliders[bf].refine = renderState.refine;
              var range = renderState.range;
              var start = renderState.start;
              if (range && range.min != null && range.max != null && range.min !== range.max) {
                facetEl.style.display = '';
                var clampedMin = Math.max(range.min, Math.min(range.max, parseFloat(minInp.value) || range.min));
                var clampedMax = Math.max(range.min, Math.min(range.max, parseFloat(maxInp.value) || range.max));
                minInp.min = range.min; minInp.max = range.max;
                maxInp.min = range.min; maxInp.max = range.max;
                // Sync appliedMin/appliedMax from IS.js start (authoritative source for stateToRoute)
                sliders[bf].appliedMin = (start && isFinite(start[0])) ? start[0] : null;
                sliders[bf].appliedMax = (start && isFinite(start[1])) ? start[1] : null;
                var isCleared = !start || (!isFinite(start[0]) && !isFinite(start[1]));
                if (!_initialized || isCleared) {
                  _initialized = true;
                  // On first init: restore from start (set by routeToState) or reset to full range
                  minInp.value = (start && isFinite(start[0])) ? start[0] : range.min;
                  maxInp.value = (start && isFinite(start[1])) ? start[1] : range.max;
                  updateUI();
                } else {
                  // If a specific bound was cleared (start is Infinity/-Infinity), reset that thumb
                  // to the range edge so the slider UI stays in sync with the active filter state
                  minInp.value = (start && isFinite(start[0])) ? clampedMin : range.min;
                  maxInp.value = (start && isFinite(start[1])) ? clampedMax : range.max;
                  updateUI();
                }
                var labelEl = facetEl.querySelector('.ms-facet-label');
                var isActive = start && (isFinite(start[0]) || isFinite(start[1]));
                if (labelEl) labelEl.classList.toggle('ms-facet-label--active', !!isActive);
              } else {
                facetEl.style.display = 'none';
              }
            }
          );
          _search.addWidgets([renderSlider({ attribute: ef })]);
        }(baseField, effectiveField, facetEl, minInput, maxInput, sliderFill, valMin, valMax,
          filter.stripPrefix || filter.prefix || '', filter.stripSuffix || filter.suffix || '', parseFloat(filter.step) || 1));

      } else {
        var facetEl = document.getElementById('ms-facet-' + baseField);
        var ul = document.getElementById('ms-facet-list-' + baseField);
        if (!facetEl || !ul) return;

        var currentRefine = null;
        var currentItems = [];

        ul.addEventListener('change', function (e) {
          if (e.target.type === 'checkbox' && currentRefine) {
            currentRefine(e.target.dataset.value);
          }
        });

        var customRefinement = window.instantsearch.connectors.connectRefinementList(
          function (renderState, isFirstRender) {
            currentRefine = renderState.refine;
            currentItems = renderState.items;
            if (isFirstRender) return;
            facetEl.style.display = renderState.items.length === 0 ? 'none' : '';
            if (renderState.items.length === 0) return;
            var hasRefined = renderState.items.some(function (i) { return i.isRefined; });
            var labelEl = facetEl.querySelector('.ms-facet-label');
            if (labelEl) labelEl.classList.toggle('ms-facet-label--active', hasRefined);
            ul.innerHTML = renderState.items.map(function (item) {
              var inputId = 'ms-facet-' + sanitizeId(baseField) + '-' + sanitizeId(item.value);
              return (
                '<li>' +
                '<input type="checkbox"' +
                ' id="' + inputId + '"' +
                ' class="ms-facet-option"' +
                ' data-value="' + escapeHtml(item.value) + '"' +
                (item.isRefined ? ' checked' : '') + '>' +
                '<label for="' + inputId + '" class="ms-facet-option-label' + (item.isRefined ? ' ms-facet-option-label--active' : '') + '">' +
                '<span class="ms-facet-option-value">' + escapeHtml(item.label) + '</span>' +
                '<span class="ms-facet-option-count">(' + item.count + ')</span>' +
                '</label>' +
                '</li>'
              );
            }).join('');
          }
        );

        _search.addWidgets([customRefinement({
          attribute: effectiveField,
          operator: 'or',
          limit: 100,
          sortBy: ['name:asc']
        })]);
      }
    });

    var _currentRefinementsState = null;

    function renderActiveFacetsHtml(items) {
      if (!items || !items.length) return '';

      // In IS.js v4, `type` lives on each refinement (r.type), not on the item.
      // Classify each refinement individually: numeric refinements (with operator)
      // get separate chips per bound; everything else is a list chip.
      var numericByAttr = {};
      var orderedAttrs = [];
      var listItems = [];

      items.forEach(function (item) {
        var numericRefs = [];
        var otherRefs = [];
        item.refinements.forEach(function (r) {
          if (r.type === 'numeric' || r.operator) {
            numericRefs.push(r);
          } else {
            otherRefs.push(r);
          }
        });
        if (numericRefs.length) {
          if (!numericByAttr[item.attribute]) {
            numericByAttr[item.attribute] = { attribute: item.attribute, refinements: [], refineItems: [] };
            orderedAttrs.push(item.attribute);
          }
          numericRefs.forEach(function (r) {
            numericByAttr[item.attribute].refinements.push(r);
          });
          numericByAttr[item.attribute].refineItems.push(item);
        }
        if (otherRefs.length) {
          listItems.push({ attribute: item.attribute, refinements: otherRefs, refine: item.refine });
        }
      });

      function fmtRangeVal(attr, n) {
        var f = effectiveFieldToFilter[attr];
        var pre = (f && (f.stripPrefix || f.prefix)) || '';
        var suf = (f && (f.stripSuffix || f.suffix)) || '';
        return pre + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'") + suf;
      }

      var tags = [];

      // One chip per bound — min and max are independent
      orderedAttrs.forEach(function (attr) {
        var merged = numericByAttr[attr];
        merged.refinements.forEach(function (r) {
          var isMin = (r.operator === '>=' || r.operator === '>');
          var label = escapeHtml(fieldLabelMap[attr] || attr);
          var valueText = (isMin ? '\u2265 ' : '\u2264 ') + fmtRangeVal(attr, r.value);
          tags.push(
            '<div class="ms-active-facet">' +
            '<span class="ms-active-facet-option">' + label + ': </span>' +
            '<span class="ms-active-facet-value">' + escapeHtml(valueText) + '</span>' +
            '<span class="ms-active-facet-x"' +
            ' data-attr="' + escapeHtml(attr) + '"' +
            ' data-op="' + escapeHtml(r.operator) + '"' +
            ' data-val="' + escapeHtml(String(r.value)) + '">clear</span>' +
            '</div>'
          );
        });
      });

      listItems.forEach(function (item) {
        item.refinements.forEach(function (r) {
          tags.push(
            '<div class="ms-active-facet">' +
            '<span class="ms-active-facet-option">' + escapeHtml(fieldLabelMap[item.attribute] || item.attribute) + ': </span>' +
            '<span class="ms-active-facet-value">' + escapeHtml(r.label) + '</span>' +
            '<span class="ms-active-facet-x" data-attr="' + escapeHtml(item.attribute) + '" data-val="' + escapeHtml(String(r.value)) + '">clear</span>' +
            '</div>'
          );
        });
      });

      return tags.join('<span>|</span>');
    }

    function syncActiveFacets(items) {
      var wrapper = document.getElementById('ms-active-facets-container');
      var desktop = document.getElementById('ms-active-facets');
      var modal = document.getElementById('ms-modal-active-facets');
      var hasRefinements = items && items.length > 0 && items.some(function (i) { return i.refinements.length > 0; });

      if (wrapper) wrapper.style.display = hasRefinements ? '' : 'none';

      var html = renderActiveFacetsHtml(items);

      if (desktop) desktop.innerHTML = html;

      if (modal) {
        var removeAllHtml = hasRefinements
          ? '<div class="ms-facets-remove-all" id="ms-modal-remove-all"><span>Alles löschen</span></div>'
          : '';
        modal.innerHTML = hasRefinements
          ? removeAllHtml + '<div class="ms-active-facets">' + html + '</div>'
          : '';
      }
    }

    function handleActiveFacetClick(e) {
      var x = e.target.closest('.ms-active-facet-x');
      if (!x || !_currentRefinementsState) return;
      var attr = x.dataset.attr;
      var op = x.dataset.op;   // set for range chips
      var val = x.dataset.val;
      if (op) {
        // Range chip: op is '>=' / '<=' (or '>' / '<' in rare IS.js versions)
        var isMinOp = (op === '>=' || op === '>');
        // Clear tracked state BEFORE helper.change — stateToRoute fires synchronously on helper change
        sortedFilters.forEach(function (f) {
          if (isSliderFilter(f) && getEffectiveField(f) === attr && sliders[f.meilisearchField]) {
            if (isMinOp) sliders[f.meilisearchField].appliedMin = null;
            else sliders[f.meilisearchField].appliedMax = null;
          }
        });
        // Remove directly via helper — avoids any r.value float-mismatch with _currentRefinementsState.refine()
        _search.helper.removeNumericRefinement(attr, op);
        _search.helper.search();
        return;
      }
      // List filter: match by value
      var matched = false;
      _currentRefinementsState.items.forEach(function (item) {
        if (item.attribute === attr) {
          item.refinements.forEach(function (r) {
            if (String(r.value) === val) {
              matched = true;
              _currentRefinementsState.refine(r);
            }
          });
        }
      });
      if (!matched) {
        console.warn('[ms] list filter: NO MATCH found for attr=' + attr + ' val=' + val);
      }
    }

    function handleRemoveAll(e) {
      if (!e.target.closest('.ms-facets-remove-all')) return;
      if (!_currentRefinementsState) return;
      // Clear all range state BEFORE refine — stateToRoute fires immediately on helper change
      Object.keys(sliders).forEach(function (k) {
        sliders[k].appliedMin = null; sliders[k].appliedMax = null;
      });
      _currentRefinementsState.items.forEach(function (item) {
        item.refinements.forEach(function (r) {
          _currentRefinementsState.refine(r);
        });
      });
    }

    var renderCurrentRefinements = window.instantsearch.connectors.connectCurrentRefinements(
      function (renderState, isFirstRender) {
        _currentRefinementsState = renderState;
        syncActiveFacets(renderState.items);

        if (isFirstRender) {
          document.addEventListener('click', function (e) {
            handleActiveFacetClick(e);
            handleRemoveAll(e);
          });
        }
      }
    );
    _search.addWidgets([renderCurrentRefinements({})]);

    var renderStats = window.instantsearch.connectors.connectStats(
      function (renderState) {
        var el = document.getElementById('ms-pg-count');
        if (el) el.textContent = renderState.nbHits + ((config.currentLocale === 'fr') ? ' Produits' : ' Produkte');
      }
    );
    _search.addWidgets([renderStats({})]);

    var sortSpans = document.querySelectorAll('.ms-sort-option');
    var sortItems = [];
    sortSpans.forEach(function (span) {
      var val = span.dataset.value
        ? MEILISEARCH_INDEX + ':' + span.dataset.value
        : DEFAULT_SORT;
      sortItems.push({ label: span.textContent.trim(), value: val });
    });

    var renderSortBy = window.instantsearch.connectors.connectSortBy(
      function (renderState, isFirstRender) {
        sortSpans.forEach(function (span) {
          var val = span.dataset.value
            ? MEILISEARCH_INDEX + ':' + span.dataset.value
            : DEFAULT_SORT;
          var isActive = val === renderState.currentRefinement;
          span.classList.toggle('ms-sort-option--active', isActive);
          if (isActive) {
            var trigger = document.querySelector('.ms-sort-select-trigger');
            if (trigger) trigger.textContent = span.textContent.trim();
          }
        });

        if (isFirstRender) {
          sortSpans.forEach(function (span) {
            span.addEventListener('click', function () {
              var val = span.dataset.value
                ? MEILISEARCH_INDEX + ':' + span.dataset.value
                : DEFAULT_SORT;
              renderState.refine(val);
            });
          });
        }
      }
    );
    _search.addWidgets([renderSortBy({ items: sortItems })]);

    var _showMore = null;
    var _didClickShowMore = false;

    var renderHits = window.instantsearch.connectors.connectInfiniteHits(
      function (renderState, isFirstRender) {
        var container = document.getElementById('ms-hits');
        var showMoreBtn = document.querySelector('.ms-show-more-btn');
        if (!container) return;

        _showMore = renderState.showMore;

        if (isFirstRender) {
          if (showMoreBtn) showMoreBtn.style.display = 'none';

          if (showMoreBtn && !showMoreBtn._msListener) {
            showMoreBtn._msListener = true;
            showMoreBtn.addEventListener('click', function () {
              _didClickShowMore = true;
              if (_showMore) _showMore();
            });
          }
          return;
        }

        // Dispatch grid loaded event on first real render
        if (!_msGridLoaded) {
          _msGridLoaded = true;
          window.dispatchEvent(new CustomEvent('meilisearch_grid_loaded'));
        }

        var toolbarEl = document.querySelector('.ms-toolbar');
        if (toolbarEl) toolbarEl.classList.add('ms-toolbar--ready');

        if (showMoreBtn) {
          showMoreBtn.style.display = renderState.isLastPage ? 'none' : '';
          showMoreBtn.disabled = renderState.showMoreLoading;
        }

        var wrapperEl = document.getElementById('ms-pg-wrapper');
        var noResultsEl = document.getElementById('meilisearch-no-results');

        if (searchMode && renderState.hits.length === 0) {
          container.innerHTML = '';
          if (wrapperEl) wrapperEl.style.display = 'none';
          if (noResultsEl) noResultsEl.style.display = 'block';
        } else if (renderState.hits.length === 0) {
          container.innerHTML = '<li class="ms-pg-no-results">' + (config.noProductsMessage || 'Keine Produkte gefunden.') + '</li>';
        } else {
          if (noResultsEl) noResultsEl.style.display = 'none';
          if (wrapperEl) wrapperEl.style.display = '';
          _refreshCompareIds();
          // Only append when user explicitly clicked "show more";
          // any filter/sort change should fully re-render the grid.
          if (_didClickShowMore) {
            _didClickShowMore = false;
            var existingCards = container.querySelectorAll('.ms-product-card-container:not([style*="pointer-events"])');
            var newHits = renderState.hits.slice(existingCards.length);
            if (newHits.length) {
              container.insertAdjacentHTML('beforeend', newHits.map(renderHitHtml).join(''));
              _reinitSwym();
            }
          } else {
            container.innerHTML = renderState.hits.map(renderHitHtml).join('');
            _reinitSwym();
          }
          fetchMsBrandDelivery();
        }
      }
    );
    _search.addWidgets([renderHits({})]);

    if (searchMode) {
      var virtualSearchBox = window.instantsearch.connectors.connectSearchBox(function () { });
      _search.addWidgets([virtualSearchBox({})]);
    }

    // Category tab integration - only filter on the "produkte" tab
    // tabs on other tabs (ubersicht, weitere-infos, ratgeber) keep default navigation
    var produkteTabContainer = document.querySelector('.product-filters-menu[data-tab="produkte"]');
    var categoryTabItems = document.querySelectorAll('[data-maincategory-handle]');
    var produkteTabItems = produkteTabContainer
      ? produkteTabContainer.querySelectorAll('[data-maincategory-handle]')
      : [];
    var _selectedCategoryId = null;

    if (produkteTabItems.length) {
      // Click handler for produkte tab only (capture phase to run before global.js handler)
      document.addEventListener('click', function (e) {
        var item = e.target.closest('[data-maincategory-handle]');
        if (!item || !_search || !_search.helper) return;

        // Only intercept clicks inside the produkte tab - let other tabs navigate normally
        if (!item.closest('.product-filters-menu[data-tab="produkte"]')) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var id = (item.getAttribute('data-maincategory-id') || '').trim();
        if (!id) return;

        // Single-select toggle
        if (_selectedCategoryId === id) {
          _selectedCategoryId = null;
        } else {
          _selectedCategoryId = id;
        }

        // Rebuild filters with optional category filter
        var filters = baseFilters.slice();
        if (_selectedCategoryId) {
          filters.push('collections.id = ' + _selectedCategoryId);
        }
        _search.helper.setQueryParameter('filters', filters.join(' AND ')).search();

        // Update active state on produkte tabs only
        produkteTabItems.forEach(function (el) {
          var elId = (el.getAttribute('data-maincategory-id') || '').trim();
          var link = el.querySelector('.af-maincategory');
          if (link) {
            if (elId === _selectedCategoryId) {
              link.classList.add('main-af-active');
              link.classList.remove('no-cross');
            } else {
              link.classList.remove('main-af-active');
            }
          }
        });
      }, true);
    }

    // Fetch facet distribution directly from meilisearch (the adapter loses nested field facets)
    function fetchCategoryFacets() {
      if (!produkteTabItems.length) return;
      var indexName = MEILISEARCH_INDEX.split(':')[0];
      var query = {
        indexUid: indexName,
        q: searchMode ? initialQuery : '',
        facets: ['collections.id'],
        limit: 0
      };
      if (baseFilterString) query.filter = baseFilterString;

      fetch(MEILISEARCH_HOST + '/multi-search', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + MEILISEARCH_API_KEY
        },
        body: JSON.stringify({ queries: [query] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var result = data.results && data.results[0] ? data.results[0] : {};
          var facetDist = (result.facetDistribution || {})['collections.id'] || {};
          applyCategoryTabVisibility(facetDist);
        })
        .catch(function (err) {
          console.error('[ms-cat] facet fetch error:', err);
        });
    }

    function applyCategoryTabVisibility(facetDist) {
      // Only hide/show tabs in the produkte tab - other tabs keep default visibility
      produkteTabItems.forEach(function (el) {
        var id = (el.getAttribute('data-maincategory-id') || '').trim();
        if (facetDist[id] && facetDist[id] > 0) {
          el.style.display = '';
        } else {
          el.style.setProperty('display', 'none', 'important');
        }
      });

      // Update produkte tab container visibility and grid layout
      if (!produkteTabContainer) return;
      produkteTabContainer.querySelectorAll('.af-maincategory-tabs').forEach(function (tabList) {
        var visibleItems = [];
        var hiddenItems = [];
        tabList.querySelectorAll('[data-maincategory-handle]').forEach(function (vi) {
          if (vi.style.display !== 'none') {
            visibleItems.push(vi);
          } else {
            hiddenItems.push(vi);
          }
        });
        // Reorder DOM: visible items first so nth-child CSS rules count correctly
        visibleItems.concat(hiddenItems).forEach(function (item) {
          tabList.appendChild(item);
        });
        var visibleCount = visibleItems.length;

        var parent = tabList.closest('.collection-subcategories');
        if (visibleCount === 0) {
          if (parent) parent.style.display = 'none';
        } else {
          if (parent && !parent.classList.contains('hidden')) parent.style.display = '';
          // Remove existing viewmore button if present
          var existingViewmore = tabList.querySelector('.viewmore-wrapper');
          if (existingViewmore) existingViewmore.remove();

          if (visibleCount < 7) {
            tabList.classList.add('tabs-small-grid');
            tabList.classList.remove('tabs-large-grid');
          } else {
            tabList.classList.add('tabs-large-grid');
            tabList.classList.remove('tabs-small-grid');
            if (parent) parent.classList.add('show-more-sec');
            // Add view-more toggle button
            var allLabel = config.allRoomsLabel || 'Alle Räume ansehen';
            var fewLabel = config.fewRoomsLabel || 'Weniger Räume ansehen';
            var viewmoreHtml = '<span class="viewmore-wrapper">'
              + '<div class="viewmore-Link" style="text-decoration:underline">'
              + '<button id="toggleBtn">' + allLabel + '</button>'
              + '</div></span>';
            tabList.insertAdjacentHTML('beforeend', viewmoreHtml);
            var toggleBtn = tabList.querySelector('#toggleBtn');
            var isOpen = false;
            toggleBtn.addEventListener('click', function () {
              isOpen = !isOpen;
              if (isOpen) {
                tabList.classList.add('show-more');
                toggleBtn.textContent = fewLabel;
              } else {
                tabList.classList.remove('show-more');
                toggleBtn.textContent = allLabel;
              }
            });
          }
        }
      });
    }

    _search.start();

    fetchCategoryFacets();

    initMobileFilter();
  }

  function initMobileFilter() {
    var toggle = document.getElementById('ms-pg-filter-toggle');
    var sidebar = document.getElementById('ms-pg-sidebar');
    var close = document.getElementById('ms-pg-sidebar-close');

    if (!toggle || !sidebar) return;

    toggle.addEventListener('click', function () {
      sidebar.classList.add('ms-pg-sidebar--open');
      document.body.classList.add('ms-pg-overlay-active');
    });

    function closeSidebar() {
      sidebar.classList.remove('ms-pg-sidebar--open');
      document.body.classList.remove('ms-pg-overlay-active');
    }

    if (close) close.addEventListener('click', closeSidebar);

    document.addEventListener('click', function (e) {
      if (
        document.body.classList.contains('ms-pg-overlay-active') &&
        !sidebar.contains(e.target) &&
        !toggle.contains(e.target)
      ) {
        closeSidebar();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }

})();